import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import { loadLanguageAsync } from '@/i18n'

Vue.use(VueRouter)

const isAuthEnabled = () => Boolean(store.getters.tourFeatures.authentication.enabled)

const init = (to, from, next) => {
  store
    .dispatch('FETCH_VIRTUAL_TOUR_DATA', process.env.VUE_APP_TOUR)
    .then(() => store.dispatch('FETCH_MEDIA_HOTSPOTS_DATA'))
    .then(() => {
      const lang = store.getters.tourFeatures.lang.default || 'en'
      // set default language
      loadLanguageAsync(lang).then(() => {
        store.dispatch('SET_LANGUAGE', lang)
        // set starting scene parameters
        if (Object.keys(to.query).length > 0) {
          store.dispatch('SET_STARTING_PARAMS', to.query)
        }
        // set page title
        store.dispatch('APP_SET_PAGE_TITLE')

        // chech if auth is required
        if (isAuthEnabled()) {
          store.dispatch('AUTH_INIT', store.getters.tourFeatures.authentication.config)
          store.dispatch('AUTH_IS_LOGGED_IN').then(() => {
            if (to.name === 'login' && (!isAuthEnabled() || store.getters.isAuthenticated)) {
              next({ name: 'main' })
            } else {
              next()
            }
          })
        } else {
          if (to.name === 'login') {
            next({ name: 'main' })
          } else {
            next()
          }
        }
      })
    })
}

const requireAuth = (to, from, next) => {
  if (isAuthEnabled() && !store.getters.isAuthenticated) next({ name: 'login' })
  else next()
}

const routes = [
  {
    name: 'main',
    path: '/',
    component: () => import('@/views/Room.vue'),
    beforeEnter: requireAuth
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    name: 'catchAll',
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(init)

export default router
